export default {
    BCG: 15,
}